/**
 * Supabase has been RETIRED — Firestore is the single source of truth.
 * This is a harmless no-op shim so legacy imports keep compiling while the
 * remaining pages migrate. It performs no network calls and ships no keys.
 */
const noop = async () => ({ data: null, error: null });

const query = {
  select() { return this; },
  insert: noop,
  update() { return this; },
  upsert: noop,
  delete() { return this; },
  eq() { return this; },
  in() { return this; },
  order() { return this; },
  limit() { return this; },
  single: noop,
  maybeSingle: noop,
  then(resolve) { return Promise.resolve({ data: [], error: null }).then(resolve); },
};

export const supabase = {
  from: () => ({ ...query }),
  rpc: noop,
  channel: () => ({ on() { return this; }, subscribe() { return this; } }),
  removeChannel: () => {},
};

export default supabase;
